const headRowsService = {
  item: 'Item',
  name: 'Equipamento',
  business: 'Tipo de Serviço',
  site: 'Periodicidade'
};

export default headRowsService;
